export enum WeekDays {
  monday = 'Segunda-feira',
  tuesday = 'Terça-feira',
  wednesday = 'Quarta-feira',
  thursday = 'Quinta-feira',
  friday = 'Sexta-feira',
  saturday = 'Sábado',
  sunday = 'Domingo',
}
export interface IPartnerList {
  list: IPartner[];
  count: number;
  totalPages: number;
  uf: string;
}

export interface IPartnerWorkingHour {
  start: string;
  end: string;
  interval: { start: string; end: string };
  open: boolean;
  dayLong: boolean;
}
export interface IPartnerWorkingHours {
  monday: IPartnerWorkingHour;
  tuesday: IPartnerWorkingHour;
  wednesday: IPartnerWorkingHour;
  thursday: IPartnerWorkingHour;
  friday: IPartnerWorkingHour;
  saturday: IPartnerWorkingHour;
  sunday: IPartnerWorkingHour;
}
export interface IPartnerDiscountSubcategories {
  [key: string]: {
    isSelected: boolean;
    name: string;
    title: string;
  };
}

export interface IPartnerDiscountCategories {
  [key: string]: {
    title: string;
    isSelected: boolean;
    subcategories: IPartnerDiscountSubcategories;
    name?: string;
  };
}

export interface IPartnerDiscount {
  discountValue: number | string;
  categories: IPartnerDiscountCategories;
}

export interface IDiscountsHistoric {
  list: {
    createdAt: string;
    discounts: IPartnerDiscount[];
    _id: string;
  }[];
  count: number;
  totalPages: number;
}

export interface IPartnerFile {
  name: string;
  key: string;
  url: string;
  path: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
}

export interface IPartnerAdddress {
  cep: string;
  street: string;
  complement: string;
  number: string;
  neighborhood: string;
  city: string;
  state: string;
  location?: {
    type: 'Point';
    coordinates: string[];
    _id: string;
  };
  _id?: string;
  completeAddress?: string;
}
export interface IPartner {
  id?: string;
  _id?: string;
  company: string;
  phone: string;
  mobilePhone: {
    number: string;
    isWhatsapp: boolean;
  };
  cnpj?: string | null;
  cpf?: string | null;
  email: string;
  responsible: string;
  crmv: string;
  discount?: string;
  socialReason: string;
  partnershipContract?: IPartnerFile;
  image?: IPartnerFile;
  uf: string;
  active: boolean;
  address?: IPartnerAdddress;
  types: {
    petshop: boolean;
    healthInstitution: boolean;
    sponsor: boolean;
    others: boolean;
  };
  socialMedias: {
    facebook: string;
    instagram: string;
    website: string;
  };
  workingHours: IPartnerWorkingHours;
  discounts: IPartnerDiscount[];
  parsedDiscounts: {
    discountValue: number;
    description: string;
  }[];
  status: IPartnerStatus;
  createdAt?: string;
}

export type ITypesPartner =
  | 'petshop'
  | 'healthInstitution'
  | 'sponsor'
  | 'others';

export interface IPartnerCreate extends IPartner {
  /* Image file to be uploaded */
  imageFile: File | null;
  /* Contract file to be uploaded */
  partnershipContractFile: File | null;
  /* Local field used to store temporary changes on workingHours */
  workingHoursUpdate: IPartnerWorkingHours;
  acceptPartnershipTerms?: { acceptedDate?: Date; isAccepted: boolean };
  /* Local field used to store temporary changes on discounts */
  discountsUpdate: IPartnerDiscount[];
  isValidMinDiscount?: boolean;
}

const defaultWorkingHour: IPartnerWorkingHour = {
  start: '',
  end: '',
  interval: { start: '', end: '' },
  open: false,
  dayLong: false,
};

export const partnerDefaultValues: IPartnerCreate = {
  cnpj: '',
  company: '',
  cpf: '',
  email: '',
  phone: '',
  mobilePhone: { isWhatsapp: false, number: '' },
  uf: '',
  socialReason: '',
  address: {
    cep: '',
    city: '',
    complement: '',
    number: '',
    neighborhood: '',
    street: '',
    state: '',
  },
  active: true,
  types: {
    petshop: false,
    healthInstitution: false,
    sponsor: false,
    others: false,
  },
  workingHours: {
    monday: defaultWorkingHour,
    tuesday: defaultWorkingHour,
    wednesday: defaultWorkingHour,
    thursday: defaultWorkingHour,
    friday: defaultWorkingHour,
    saturday: defaultWorkingHour,
    sunday: defaultWorkingHour,
  },
  workingHoursUpdate: {
    monday: defaultWorkingHour,
    tuesday: defaultWorkingHour,
    wednesday: defaultWorkingHour,
    thursday: defaultWorkingHour,
    friday: defaultWorkingHour,
    saturday: defaultWorkingHour,
    sunday: defaultWorkingHour,
  },
  crmv: '',
  discount: '',
  partnershipContract: undefined,
  image: undefined,
  responsible: '',
  socialMedias: {
    facebook: '',
    instagram: '',
    website: '',
  },
  imageFile: null,
  partnershipContractFile: null,
  discounts: [],
  parsedDiscounts: [],
  status: 'pending',
  discountsUpdate: [],
  acceptPartnershipTerms: { isAccepted: false },
};

export const PartnerDiscountCategories = [
  'Ração (seca, úmida, petiscos ou ossos)',
  'Produtos de higiene (tapetes higiênicos, fraldas, sabonetes, shampoo, higiene bucal, areia e etc)',
  'Medicamentos',
  'Brinquedos e coleiras',
  'Serviços (banho, tosa ou hotel)',
  'Exames',
  'Outros',
];
export const ThemeStatus = {
  approved: { color: '#4CAF50', title: 'Ativo' },
  rejected: { color: '#F24E1E', title: 'Recusado' },
  pending: { color: '#FF9800', title: 'Pendente' },
};

export type IPartnerStatus = keyof typeof ThemeStatus;

export const DiscountCategories = {
  foods: {
    title: 'Rações',
    subcategories: {
      dry: { isSelected: true, title: 'Seca' },
      damp: { isSelected: true, title: 'Úmida' },
      snack: { isSelected: true, title: 'Petisco' },
      bone: { isSelected: true, title: 'Osso' },
    },
  },
  hygienics: {
    title: 'Higiene',
    subcategories: {
      hygienicCarpet: {
        isSelected: true,
        title: 'Tapete higiênico',
      },
      diaper: { isSelected: true, title: 'Fralda' },
      soap: { isSelected: true, title: 'Sabão' },
      shampoo: { isSelected: true, title: 'Shampoo' },
      oralHygiene: {
        isSelected: true,
        title: 'Higiene bucal',
      },
      sand: { isSelected: true, title: 'Areia' },
    },
  },
  medications: {
    isSelected: true,
    title: 'Medicamentos',
  },
  toys: { isSelected: true, title: 'Brinquedos' },
  leashes: { isSelected: true, title: 'Coleiras' },
  services: {
    title: 'Serviços',
    subcategories: {
      bath: { isSelected: true, title: 'Banho' },
      groom: { isSelected: true, title: 'Tosa' },
      hotel: { isSelected: true, title: 'Hotel' },
    },
  },
  exams: { isSelected: true, title: 'Exames' },
  others: { name: '', isSelected: true, title: 'Outros' },
};

export const DiscountCategoriesDefault = {
  foods: {
    title: 'Rações',
    subcategories: {
      dry: { isSelected: false, title: 'Seca' },
      damp: { isSelected: false, title: 'Úmida' },
      snack: { isSelected: false, title: 'Petisco' },
      bone: { isSelected: false, title: 'Osso' },
    },
  },
  hygienics: {
    title: 'Higiene',
    subcategories: {
      hygienicCarpet: {
        isSelected: false,
        title: 'Tapete higiênico',
      },
      diaper: { isSelected: false, title: 'Fralda' },
      soap: { isSelected: false, title: 'Sabão' },
      shampoo: { isSelected: false, title: 'Shampoo' },
      oralHygiene: {
        isSelected: false,
        title: 'Higiene bucal',
      },
      sand: { isSelected: false, title: 'Areia' },
    },
  },
  medications: {
    isSelected: false,
    title: 'Medicamentos',
  },
  toys: { isSelected: false, title: 'Brinquedos' },
  leashes: { isSelected: false, title: 'Coleiras' },
  services: {
    title: 'Serviços',
    subcategories: {
      bath: { isSelected: false, title: 'Banho' },
      groom: { isSelected: false, title: 'Tosa' },
      hotel: { isSelected: false, title: 'Hotel' },
    },
  },
  exams: { isSelected: false, title: 'Exames' },
  others: { name: '', isSelected: false, title: 'Outros' },
};
